<template>
    <div :class="{nav:true, open: isMenuOpen}">
<!--        <div class="filter">-->
<!--            <input type="text" placeholder="Filtra un tema..." v-model="menuFilter" class="filterField">-->
<!--        </div>-->
        <tree
            ref="menu"
            :data="course.nav"
            :options="menuOptions"
            class="tree-highlights"
            :filter="menuFilter"
            @node:expanded="onNodeExpand"
        >
        </tree>
    </div>
</template>

<script>
    import Vue from 'vue'
    import LiquorTree from 'liquor-tree'
    import {mapState} from 'vuex'

    Vue.use(LiquorTree);

    export default {
        name: "navBar",

        props:{
            course: {
                type: Object,
                required: true
            },
            theme: {
                // type: String,
                default: null
            }
        },
        watch:{
            theme: function (newVal) {
                this.selectNode(newVal)

            }
        },
        computed: {
            eventsList() {
                return this.events.concat().reverse()
            },
            ...mapState(['isMenuOpen'])
        },
        data() {
            return {
                menuOptions: {
                    miltiple: false,
                    checkOnSelect: true,
                    filter: {
                        emptyText: 'Prueba buscando otro tema'
                    }
                },
                menuFilter: '',
                events: [],
            }
        },
        mounted(){
            eventsList.forEach(e => {
                this.$refs.menu.$on(e.name, this.initEventViewer(e))
            });
            // this.selectNode(this.$route.params.theme)
        },
        methods: {
            onNodeExpand(node) {
                const expandedNodes = this.$refs.menu.findAll({ state: { expanded: true } });

                expandedNodes.forEach(expandedNode => {
                    if (expandedNode.id !== node.id && node.depth === expandedNode.depth) {
                        expandedNode.collapse()
                    }
                })
            },
            selectNode(n){
                let tree = this.$refs.menu;
                let selection = tree.selected();
                selection.unselect();
                // console.log(n)
                // console.log(tree)
                let node = tree.find(n.text);

                if (node[0]) {
                    node[0].select(true)
                    node[0].expand()
                }
                // In our example we have one selected node. Using API we are able to find Node:
                // let someCoolNode = this.$refs.tree.find('Awesome NODE')

            },
            initEventViewer(event) {
               return  (node, newNode) => {
                   // let nodeText = '-'
                   let targetNode = newNode && newNode.text ? newNode : node;

                   // if (targetNode && targetNode.text) {
                   //     nodeText = targetNode.text
                   // }
                   if (event.name === `node:clicked`) {
                       this.$emit('nodeClick', targetNode)
                   }
               }
            }
        }
    }
    const eventsList = [
        { name: 'tree:mounted', args: ['Tree Component'] },
        { name: 'tree:filtered', args: ['Matches', 'Filter String'] },
        { name: 'tree:data:fetch', args: ['Parent Node'] },
        { name: 'tree:data:received', args: ['Parent Node'] },

        { name: 'node:clicked', args: ['Node']},
        { name: 'node:disabled', args: ['Node']},
        { name: 'node:enabled', args: ['Node']},
        { name: 'node:shown', args: ['Node'] },
        { name: 'node:hidden', args: ['Node'] },
        { name: 'node:dblclick', args: ['Node'] },
        { name: 'node:selected', args: ['Node'] },
        { name: 'node:unselected', args: ['Node'] },
        { name: 'node:checked', args: ['Node'] },
        { name: 'node:unchecked', args: ['Node'] },
        { name: 'node:expanded', args: ['Node'] },
        { name: 'node:collapsed',  args: ['Node'] },
        { name: 'node:added',  args: ['Node', 'New Node'] },
        { name: 'node:removed',  args: ['Node'] },
        { name: 'node:text:changed', args: ['Node', 'New Text', 'Old Text']},

        { name: 'node:editing:start',  args: ['Node'] },
        { name: 'node:editing:stop',  args: ['Node', 'isTextChanged'] },
    ]
</script>

<style lang="scss">
    $main-color: rgba(50, 197, 210, 1);
    $main-color-hover: rgba(50, 197, 210, .7);
.tree-highlights.tree{
    overflow-x: hidden !important;
}
    .filter{
        margin: 1em 0 0;
        width: 100%;
        display: flex;
        justify-content: center;
        .filterField{
            width: 90%;
            height: 2em;
        }
    }
    .tree-highlights .tree-node {
        /*white-space: nowrap;*/
        white-space: break-spaces !important;
    }
    .tree-highlights .tree-node.selected > .tree-content {
        background-color: $main-color-hover;
    }
</style>